export interface SeenEntry {
  name: string;
  time: Date;
}

export abstract class ChatMessage {
  messageId: string;
  isOwner: boolean;
  chatRoomId: string;
  senderName: string;
  isNotification: boolean;
  sentTime: Date | null;
  deliveredTime: Date | null;
  arrivalTime: Date | null;
  seenTimes: SeenEntry[];
  editedTime: Date | null;
  deletedTime: Date | null;

  constructor(
    messageId: string,
    isOwner: boolean,
    chatRoomId: string,
    senderName: string,
    sentTime: Date | null,
    deliveredTime: Date | null,
    seenTimes: SeenEntry[], 
    editedTime: Date | null,
    deletedTime: Date | null,
    arrivalTime: Date | null,
    { isNotification = false }: { isNotification?: boolean} = {}
  ) {
    this.messageId = messageId;
    this.isOwner = isOwner;
    this.chatRoomId = chatRoomId;
    this.senderName = senderName;
    this.isNotification = isNotification;
    this.sentTime = sentTime;
    this.deliveredTime = deliveredTime;
    this.seenTimes = seenTimes || [];
    this.editedTime = editedTime;
    this.deletedTime = deletedTime;
    this.arrivalTime = arrivalTime;
  }

  addSeenBy(name: string, time: Date = new Date()): void {
    if (!this.seenTimes) {
      this.seenTimes = [];
    }
    
    const existingIndex = this.seenTimes.findIndex(entry => entry.name === name);
    
    if (existingIndex !== -1) {
      this.seenTimes[existingIndex].time = time;
    } else {
      this.seenTimes.push({ name, time });
    }
  }

  hasBeenSeenBy(name: string): boolean {
    return (this.seenTimes || []).some(entry => entry.name === name);
  }

  getSeenTimeBy(name: string): Date | null {
    if (!this.seenTimes) return null;
    const entry = this.seenTimes.find(entry => entry.name === name);
    return entry ? entry.time : null;
  }

  toMap(): { [key: string]: any } {
    return {
      messageId: this.messageId,
      isOwner: this.isOwner ? 1 : 0, 
      chatRoomId: this.chatRoomId,
      senderName: this.senderName,
      isNotification: this.isNotification ? 1 : 0, 
      sentTime: this.sentTime?.toString() || null,
      deliveredTime: this.deliveredTime?.toString() || null,
      seenTimes: JSON.stringify((this.seenTimes || []).map(entry => ({
        name: entry.name,
        time: entry.time.toString()
      }))), 
      editedTime: this.editedTime?.toString() || null,
      deletedTime: this.deletedTime?.toString() || null,
      arrivalTime: this.arrivalTime?.toString() || null
    };
  }
}